<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="广告管理" />
		<el-table :data="tableData" border>
			<el-table-column label="logo" width="350">
				<div class="tit-wrap" slot-scope="scope">
					<div class="tit-img">
						<a :href="$store.state.ROOT_URL+'goodsinfo-'+scope.row.id+'.html'" target="_blank">
							<img :src="scope.row.photo"  :onerror="error_img" />
						</a>
					</div>
				</div>
			</el-table-column>
			<el-table-column label="公司名称" prop="gong_name" />
			<el-table-column label="跳转地址" prop="url" />
			<el-table-column label="日期" prop="time" />
			<el-table-column label="操作">
				<template slot-scope="scope">
					<!-- <el-button type="text" size="small" @click="handleJump(scope.row)">查看</el-button> -->
					<el-popconfirm title="确认下架吗？" @confirm="handleDel(scope.row)">
						<el-button type="text" size="small" slot="reference">下架</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
			@current-change="currentChange" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				p: 1,
				total: 0,
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				this.$axios.post('Myseller-SellerManage-posterList', {
					user_id: this.$store.state.USER_ID,
					p: this.p
				}).then(data => {
					this.total = Number(data.count) ? Number(data.count)  : ''
					this.tableData = data
					document.body.scrollTop = document.documentElement.scrollTop = 0
				})
			},
			currentChange(page) {
				this.p = page
				this.getData()
			},
			handleJump(row) {
				if (row.category == '技术文库') {
					open(`${this.$store.state.ROOT_URL}/Jswk-details-id-${row.id}.html`)
				} else if (row.category == '行业展会'|| row.category == '行业应用'  || row.category == '产业链展会' || row.category == '产业链商城') {
					open(`${this.$store.state.ROOT_URL}/Zszh-zszh_info-id-${row.id}.html`)
				} else {
					open(`${this.$store.state.ROOT_URL}/News-${row.id}.html`)
				}
			},
			handleDel(row) {
				this.$axios.post('Myseller-SellerManage-posterstatus', {
					user_id:this.$store.state.USER_ID,
					// news_adminid:row.news_adminid,
					// id: row.id,
					shopid:row.shopid
				}).then(data => {
					this.$message({
						type: 'success',
						message: '下架成功'
					})
					this.getData();
				})
			},
		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
	.tit-img img{
		max-width: 300px;
		height: 100px;
	}
</style>
